import './learning-card.scss';
import './learning-card.html.twig';
